import {
  Button,
  Form,
  Input,
  Switch,
  Radio,
  Select,
  InputNumber,
  Tag,
  Upload,
  Space,
  Row,
  Col,
  Cascader,
  message,
} from 'antd'
import { InboxOutlined, UploadOutlined, PlusOutlined } from '@ant-design/icons'
import TextArea from 'antd/lib/input/TextArea'
import './editRentReadMe.css'
import AddContent from './components/addContent/addContent'
import { useEffect, useState } from 'react'
import { MyValidateMessages } from '../../utils/validateMessaage'
import UploadOnePicture from '../../components/upLoadOnePicture/uploadPicture'
import {
  changeRentReadMe,
  changeShare,
  freshToken,
  getCategories,
  getRentReadMe,
  newShare,
  shareDetail,
} from '../../api/api'
import UploadMultiplePicture from '../../components/uploadMultiplePicture/uploadMultiplePicture'
import { useLocation, useNavigate } from 'react-router-dom'
import UploadlistTypeMultiplePicture from '../../components/uploadlistTypeMultiplePicture/uploadlistTypeMultiplePicture'
import RichTextEditor from '../../components/richText/richText'

export default function EditRentReadMe() {
  const [newContent, setNewContent] = useState([{ 1: 1 }, { 1: 1 }])
  const [data, setData] = useState()

  const [form] = Form.useForm()
  const [dictionary, setDictionary] = useState([]) //字典
  const [categoryName, setCategoryName] = useState({})
  const { Option } = Select
  const layout = {
    labelCol: {
      span: 2,
    },
    wrapperCol: {
      span: 8,
    },
  }
  const navigate = useNavigate()

  //向父组件传递图片网址
  const [url, setUrl] = useState()
  const setImgUrl = (newurl) => {
    setUrl(newurl)
    form.setFieldValue('image', newurl)
    // console.log(url);
  }
  //向父组件传递图片网址
  const [multipleImgUrl, setMultipleImgUrl] = useState([])

  //向父组件传递富文本内容
  const [richText, setRichText] = useState([])

  //编辑内容时的初始化
  const location = useLocation()
  const info = location?.state?.info ?? {}
  console.log(info, 'editInfo')

  const findName = (list, target) => {
    for (let subList of list) {
      if (subList.ID === target) {
        return subList.Name
      }
      if (subList.SubCategories) {
        let res = findName(subList.SubCategories, target)
        if (res) return res
      }
    }
  }

  const wait = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(categoryName)
      }, 300)
    })
  }

  //初始化cascader，再获取一次dictionary保证dictionary不为空
  useEffect(() => {
    setData(info)
    setUrl(info?.image)
    setMultipleImgUrl(() => {
      //将contents中的images全部取出来存在一个数组里
      const MultipleImg = []
      const contents = data?.contents
      contents?.forEach((item, index) => {
        // console.log('item', item)
        MultipleImg[index] = item.images
      })
      console.log('MultipleImg', MultipleImg)
      return MultipleImg
    })
    form.setFieldsValue(info)
  }, [])

  const onFinish = (values) => {
    form.setFieldValue('image', url)
    console.log(url)
    form.setFieldValue((e) => {
      console.log('formfiled:', e)
    })

    form.validateFields().then((res) => {
      //定义选填内容
      // console.log(res.contents)
      console.log(multipleImgUrl)
      const contents =
        res.contents === undefined
          ? []
          : res.contents.map((item, index) => {
              return {
                images: multipleImgUrl[index] ?? [],
                id: index,
                subtitle: item.subtitle,
                text: richText[index] ?? '',
              }
            })
      // console.log('content data:', res)
      const putparams = {
        ...res,
        contents: contents,
        id: data?.ID,
      }
      console.log(putparams)
      changeRentReadMe(putparams)
        .then((res) => {
          console.log(res)
          message.success('编辑内容成功！')
          navigate('/rentReadMe', { replace: true })
        })
        .catch((err) => {
          console.log(err)
        })
    })
  }

  const cancelSubmit = () => {
    navigate('/rentReadMe', { replace: true })
  }

  const add = () => {
    setNewContent([...newContent, {}])
  }
  const deleteContent = (idx) => {
    newContent.map((info, index) => {
      if (index === idx) {
        newContent.splice(idx, 1)
        setNewContent(() => {
          return [...newContent]
        })
        console.log('delete:', info)
      }
    })
  }

  const [fresh, setFresh] = useState(false)
  useEffect(() => {
    console.log('fileList', fresh)
  }, [fresh])

  //信息选填的图片的URL传递
  const changeMultipleImg = (index) => (newUrl) => {
    console.log('newUrl', newUrl)
    setFresh((pre) => !pre)
    setMultipleImgUrl((pre) => {
      // console.log('the initial img url arr',pre)
      // console.log(newUrl)
      // console.log(pre,pre.images);
      const newData = pre[index] ?? []
      newData.push(newUrl)
      // console.log(newData)
      pre[index] = newData
      return pre
    })
  }
  //信息选填的图片的URL传递
  const deliveryRichtext = (index) => (newText) => {
    // console.log("newText", newText);

    setRichText((pre) => {
      pre[index] = newText
      return pre
    })

    // 传递富文本编辑器内容给form表达，完成必填项检验
    let contentList = form.getFieldValue('contents')
    contentList[index].text = newText
    form.setFieldValue('contents', contentList)
  }

  return (
    <div className="newContent">
      <Form
        {...layout}
        name="nest-messages"
        onFinish={onFinish}
        validateMessages={MyValidateMessages}
        form={form}
        // initialValues={data ?? {}}
      >
        {/* 内容首图 */}
        <Form.Item name="image" label="内容首图" style={{ textAlign: 'left' }}>
          <UploadOnePicture
            key={data}
            deliverUrl={setImgUrl}
            image={data?.image}
          />
        </Form.Item>

        {/* 信息选填 */}
        <Form.List name="contents">
          {(fields, { remove, add, move }) => {
            return (
              <>
                {fields.map((field, index) => (
                  <div key={index}>
                    <Row>
                      <Col span={12}>
                        <Form.Item
                          labelCol={{
                            span: 4,
                          }}
                          wrapperCol={{
                            span: 16,
                          }}
                          label={'标题' + Number(index + 1)}
                          name={[field.name, 'subtitle']}
                          rules={[
                            {
                              required: true,
                              max: 8,
                            },
                          ]}
                        >
                          <Input placeholder="请输入标题，不超过8字" />
                        </Form.Item>
                      </Col>
                      <Col span={11}>
                        <div
                          style={{
                            cursor: 'pointer',
                            color: '#1890ff',
                            paddingTop: '1%',
                          }}
                          onClick={() => {
                            remove(index)
                          }}
                        >
                          删除
                        </div>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          name={[field.name, 'text']}
                          // name="text"
                          label={'内容' + Number(index + 1)}
                          labelCol={{
                            span: 4,
                          }}
                          wrapperCol={{
                            span: 16,
                          }}
                          rules={[
                            {
                              required: true,
                              // max: 2000,
                            },
                          ]}
                        >
                          <RichTextEditor
                            defaultContent={data?.contents[index]?.text ?? ''}
                            deliveryRichtext={deliveryRichtext(index)}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={16}>
                        {/* 内容图片 (最多可以上传9张图片),之后再改进*/}
                        <Form.Item
                          label={'图片' + Number(index + 1)}
                          labelCol={{ span: 3 }}
                          name={[field.name, 'images']}
                          style={{ textAlign: 'left' }}
                        >
                          <UploadMultiplePicture
                            deliverUrl={changeMultipleImg(index)}
                            key={data}
                            count={1}
                            images={data?.contents[index]?.images ?? []}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                ))}

                <Form.Item className={'text-center'}>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    style={{ width: '75vw', marginLeft: '38px' }}
                  >
                    新增内容部分
                  </Button>
                </Form.Item>
              </>
            )
          }}
        </Form.List>

        <Form.Item
          wrapperCol={{
            ...layout.wrapperCol,
            offset: 20,
            span: 24,
          }}
        >
          <div className="buttonGroup">
            <Button onClick={cancelSubmit}>取消</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: '20px' }}
              // onClick={onFinish}
            >
              提交
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}
